import { TransferBaseRequestDto } from './transfer-base-request.dto';
export class ImportRequestDto extends TransferBaseRequestDto {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	public Workfile: string;
}
